import axios from "axios";
import { rootStore } from ".";

axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'

// Ensure the base URL doesn't end with a slash
const baseUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
axios.defaults.baseURL = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;

axios.defaults.withCredentials = true

axios.interceptors.request.use((request)=>{
    if(rootStore.authStore.token){
        request.headers = {
            ...request.headers,
            Authorization: 'Bearer ' + rootStore.authStore.token
        }
    }
    return request
})

axios.interceptors.response.use(response=>response,error=>{
    if(axios.isAxiosError(error) && error.response){
        if(error.response.status === 401) rootStore.authStore.logout()
    }
    throw error
})